import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

export const formatDateForTable = (dateString: string): string => {
    return dayjs.utc(dateString).format('MM/DD/YYYY') // e.g. "08/24/2024"
}

export const formatDateRangeForTable = (
    startDate: string,
    endDate: string
): string => {
    const formattedStartDate = dayjs
        .utc(startDate, 'YYYY-MM-DD')
        .format('MM/DD/YYYY')
    const formattedEndDate = dayjs
        .utc(endDate, 'YYYY-MM-DD')
        .format('MM/DD/YYYY')
    return `${formattedStartDate} - ${formattedEndDate}`
}
